import { Routes, Route } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { ThemeProvider } from "styled-components";
import HomePage from "./pages/HomePage";
// import ServicesPage from './pages/ServicesPage';
import Services from "./pages/Services";
import SmesPage from "./pages/SmesPage";
import StartUpPage from "./pages/StartUpPage";
import ContactPage from "./pages/ContactPage";
import ImprintPage from "./pages/ImprintPage";
import theme from "./theme";
import servicesData from "./constants/services";
import ScrollToTop from "./components/ScrollToTop";
import WorkPage from "./pages/WorkPage";
import WorksPage from "./pages/WorksPage";

const App = () => {
  return (
    <>
      <ScrollToTop />
      <AnimatePresence exitBeforeEnter>
        <ThemeProvider theme={theme}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<Services data={servicesData} />} />
            <Route path="/works" element={<WorksPage />} />
            <Route path="/work/:workId" element={<WorkPage />} />
            <Route path="/smes" element={<SmesPage />} />
            <Route path="/startup" element={<StartUpPage />} />
            <Route path="/contact" element={<ContactPage />} />
            {/* <Route path="/imprint" element={<ImprintPage />} /> */}
          </Routes>
        </ThemeProvider>
      </AnimatePresence>
    </>
  );
};

export default App;
